import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-jpg-icon',
  templateUrl: './documents-jpg.component.html'
})
export class DocumentsJpgComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
